// extracted by mini-css-extract-plugin
module.exports = {"defaults":"index-module--defaults--17Yhu","primary":"index-module--primary--25H2t"};